import React from 'react'
import { useTranslation } from 'react-i18next'

import Bar from '../../../../components/pdf/Bar'
import Grid, { Col } from '../../../../components/pdf/Grid'
import Text from '../../../../components/pdf/Text'
import { useSessionPermission } from '@btime/react-session'

const Item = ({ label, value }) => (
  <Grid justify="center" gutter={3}>
    <Col gutter={3}>
      <Text noWrap>{label}:</Text>
    </Col>
    <Col gutter={3}>
      <Text bold noWrap>
        {value}
      </Text>
    </Col>
  </Grid>
)

const CounterBar = ({ counters }) => {
  const hideAttendanceTime = useSessionPermission('hideAttendanceTime')
  const { t } = useTranslation('serviceOrders')
  return (
    <Bar>
      <Grid justify="space-around">
        <Item label={t('pdf.counters.score')} value={counters.score + '%'} />
        <Item label={t('pdf.counters.nonCompliances')} value={counters.nonCompliancesCount} />
        <Item label={t('pdf.counters.actionPlans')} value={counters.actionPlansCount} />
        {!hideAttendanceTime && <Item label={t('pdf.counters.time')} value={counters.attendanceTime} />}
      </Grid>
    </Bar>
  )
}

export default CounterBar
